import { render } from "./AddType.vue?vue&type=template&id=3c3b0c60&scoped=true"
import script from "./AddType.vue?vue&type=script&lang=js"
export * from "./AddType.vue?vue&type=script&lang=js"

import "./AddType.vue?vue&type=style&index=0&id=3c3b0c60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3b0c60"]])

export default __exports__